import { Button, Result } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const StyledResult = styled(Result)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const NoAccess = () => {
  const navigation = useHistory();
  return (
    <StyledResult
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page. Please contact the administrator to give you the necessary rights."
      extra={
        <Button
          onClick={() => {
            navigation.replace('/overview');
          }}
          type="primary"
        >
          Go to overview
        </Button>
      }
    />
  );
};

export default NoAccess;
